import styled from "styled-components";
import { StyledPayoutWrapper } from "../payouts/styledPayout";
import { StyledTooltip } from "../styles/styledTooltip";

export const StyledBatchesDetailsWrapper = styled(StyledPayoutWrapper)`
  .batches-details-head {
    margin-bottom: 20px;
  }
 
  .batches-info {
    padding-bottom: 30px;
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(200px, 250px));
    grid-gap: 30px;
    border-bottom: 1px solid ${({theme}) => theme.surface.border};
    &__row {
      display: grid;
      grid-template-columns: 20px 1fr;
      grid-gap: 20px;
      align-items: center;
      span {
        color: ${({theme}) => theme.text.primary};
        font-size: 20px;
      }
    }
    &__name  p {
      width: 200px;
      display: block;
      color: ${({theme}) => theme.text.primary};
      font-size: 18px;
      font-weight: 600;
      overflow-wrap: break-word;
    }
  }
  
  .batches-process {
    padding-top: 20px;
    &__row {
      display: grid;
      grid-template-columns: repeat(6, 100px);
      grid-gap: 1px;
      &:first-child {
        padding-bottom: 1px;
        color: ${({theme}) => theme.text.primary};
        font-weight: 700;
      }
      & > div{
        text-align: center;
        border: 1px solid ${({theme}) => theme.surface.borderSoft};
      }
    }
    @media screen and (max-width: 599px) {
      &__row {
        grid-template-columns: 100%;
        &:first-child {
          display: none;
        }
        & > div{
          margin-bottom: 10px;
          padding-top: 20px;
          text-align: left;
          border: none;
          position: relative;
          &:before {
            content: attr(data-title) ':';
            color: ${({theme}) => theme.text.primary};
            font-size: 11px;
            font-weight: 700;
            letter-spacing: 0.4px;
            opacity: 0.75;
            position: absolute;
            top: 0;
            left: 0;
          }
        }
      }
    }
  }
  
  .payouts-head {
    padding: 0 0 20px;
  }
`;

export const StyledBatchesWrapper = styled.div`
  .batches-head {
    padding: 15px 0 25px;
    display: grid;
    align-items: center;
    grid-template-columns: max-content 175px 1fr;
    grid-gap: 20px;
    &__create-invoice {
      display: inline-grid;
      align-items: center;
      justify-content: end;
    }
    @media screen and (max-width: 768px) {
      grid-template-columns: max-content 175px;
      &__create-invoice {
        justify-content: start;
      }
    }
    @media screen and (max-width: 576px) {
      grid-template-columns: 100%;
    }
  }
  
  .batches-table_scroll {
    @media screen and (max-width: 992px) {
      overflow: inherit;
    }
  }
  
  .batches-table {
    &__head, &__row {
      grid-template-columns: repeat(2, minmax(250px, 1.7fr)) repeat(5, 1fr) minmax(185px, 200px);
    }
    &__actions {
      button[border="danger"] {
        color: ${({theme}) => theme.state.danger};
      }
      & > div {
        display: grid;
        grid-template-columns: 100%;
        grid-gap: 10px;
      }
    }
    
    @media screen and (max-width: 992px) {
      min-width: auto;
      overflow-x: inherit;
      &__head {
        display: none;
      }
      &__row {
        margin-bottom: 15px;
        grid-template-columns: repeat(2, 1fr);
        border: 1px solid ${({theme}) => theme.surface.border};
        & > div {
          padding-top: 20px;
          &:before {
            display: block;
          }
        }
      }
      &__actions {
        grid-column-start: 1;
        grid-column-end: 3;
        & > div {
          grid-template-columns: repeat(2, 1fr);
        }
      }
    }
    @media screen and (max-width: 599px) {
      &__row {
        padding: 15px 10px;
        grid-template-columns: 100%;
      }
      &__actions {
        grid-column-end: 1;
      }
    }
  }
`;

export const StyledBatchResults = styled.div`
  display: grid;
  grid-template-columns: repeat(4, 35px);
  grid-gap: 5px;

  &:has(${StyledTooltip}) {
    grid-template-columns: 16px repeat(4, 35px);
  }

  ${StyledTooltip} {
    grid-row: span 2;
    align-self: center;
    cursor: default;
  }
  
  & > p {
    text-align: center;
    cursor: pointer;
    position: relative;

    &:not(&:last-child) {
      &:before {
        content: "/";
        position: absolute;
        top: 0;
        left: 35px;
        opacity: 0.25;
      }
    }
  }
`;

export const StyledCreateBatches = styled.div`
  display: inline-grid;
  grid-template-rows: 45px;
  button {
    height: 100%;
  }
`;

export const StyledFileUpload = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 10px;
  padding-top: 10px;

  button {
    height: 36px;
    padding: 0 15px;
    border: 1px solid ${({theme}) => theme.button.transparentColor};
    border-radius: 5px;
    background: transparent;
    color: ${({theme}) => theme.button.transparentColor};
    font-size: 13px;
    font-weight: 600;
    font-family: inherit;
    cursor: pointer;
    &:hover {
      background: ${({theme}) => theme.overlay.hover};
    }
  }

  input[type="file"] {
    max-width: 100%;
    color: inherit;
    font-size: 13px;
  }

  input[type="file"]::-webkit-file-upload-button {
    height: 36px;
    margin-right: 10px;
    padding: 0 15px;
    border: 1px solid ${({theme}) => theme.button.transparentColor};
    border-radius: 5px;
    background: transparent;
    color: ${({theme}) => theme.button.transparentColor};
    font-size: 13px;
    font-weight: 600;
    font-family: inherit;
    cursor: pointer;
  }

  input[type="file"]::-webkit-file-upload-button:hover {
    background: ${({theme}) => theme.overlay.hover};
  }

  input[type="file"]::file-selector-button {
    height: 36px;
    margin-right: 10px;
    padding: 0 15px;
    border: 1px solid ${({theme}) => theme.button.transparentColor};
    border-radius: 5px;
    background: transparent;
    color: ${({theme}) => theme.button.transparentColor};
    font-size: 13px;
    font-weight: 600;
    font-family: inherit;
    cursor: pointer;
  }

  input[type="file"]::file-selector-button:hover {
    background: ${({theme}) => theme.overlay.hover};
  }
`;